import * as React from 'react'
import {ErrorProps} from './ResidentHocInputErrorHandling'
import {createErrorHandlingForm, ErrorHandlingFormProps} from '../hoc/createResidentErrorHandlingForm'
import {CustomResidentTextFieldStyle} from '../../../../styledComponents/residentPage/TextField'
import styled from 'styled-components'
import {InputErrorProps} from '../../../../styledComponents/DisplayItem'
import {StyledDiv} from '../../../../styledComponents/StyledTypeDefinitions'
import {FontSize} from '../../../../styledComponents/Constants'
import {IconButton} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {Visibility, VisibilityOff} from '@mui/icons-material'

interface Props {
    inputProps: React.InputHTMLAttributes<HTMLInputElement>
    onChange?: (event: any, checked?: boolean) => void
    passwordToggle?: boolean
}

export const PasswordFieldForResident = (props: Props & ErrorHandlingFormProps & ErrorProps) => {
    const [showPassword, setShowPassword] = React.useState(false)

    const handleClickShowPassword = () => setShowPassword((show) => !show)

    const {
        inputProps, hasError, clearErrorMessage, eventKeys,
        eventEmitter, errorAreaMaxWidth,
        passwordToggle, ...rest
    } = props

    return <InputArea>
        <PasswordInput
            {...inputProps}
            {...rest}
            type={showPassword ? 'text' : 'password'}
        />
        <VisibilityIconButton onClick={handleClickShowPassword}>
            {showPassword ? <PasswordVisibilityOff/> : <PasswordVisibility/>}
        </VisibilityIconButton>
    </InputArea>
}
PasswordFieldForResident.displayName = 'PPPasswordFieldForResident'

const CustomPasswordFieldForResident = styled(PasswordFieldForResident)<InputErrorProps>`
    ${CustomResidentTextFieldStyle}
`
const InputArea: StyledDiv = styled.div`
    display: flex;
    position: relative;
`
const PasswordInput = styled.input`
    // Edgeのパスワード表示アイコンと重複表示されるので無効化する
    &[type='password']::-ms-reveal {
        display: none;
    }
`
const VisibilityIconButton = withStyles({
    root: {
        padding: 0,
        position: 'absolute',
        right: '10px',
        top: '10px',
    },
})(IconButton)

const PasswordVisibilityOff = withStyles({
    root: {
        fontSize: FontSize.ExtraBig,
    },
})(VisibilityOff)

const PasswordVisibility = withStyles({
    root: {
        fontSize: FontSize.ExtraBig,
    },
})(Visibility)

export const PPPasswordFieldForResident = createErrorHandlingForm(CustomPasswordFieldForResident)
